import { customAxios } from './customAxios';

export function ricalcolaIndicatori(idMonitoraggio, fornitore) {
  const config = {
    params: {
      id: idMonitoraggio,
      tipoFornitore: fornitore
    },
    headers: {
      "AuthToken": JSON.parse(localStorage.getItem('token')),
    }
  };


  const resp = customAxios.get(process.env.REACT_APP_BACKEND_HOST + '/adv/monitoraggio/ricalcola-indicatori', config);

  return resp;
}
